const downloadWidth = 30;
const colWidth = `calc(50% - ${downloadWidth / 2}px)`;

export const columns: any = [
  {
    title: 'Date sent',
    width: colWidth,
    sortable: true,
    sortName: 'created_at',
    sort: 'desc',
    active: false,
    col: 'created_at',
    type: 'date',
    textEllipsis: true,
  },
  {
    title: 'Products',
    width: colWidth,
    sortable: true,
    sortName: 'item_count',
    sort: 'desc',
    active: false,
    col: 'item_count',
    textEllipsis: true,
  },
  {
    title: 'Download',
    width: `${downloadWidth}px`,
    sortable: false,
    active: false,
    col: 'download',
    icon: 'export-log-icon',
    align: 'center',
    textEllipsis: true,
    showIcon: true, // for sorting panel
  },
];
